import {Fragment, useEffect, useRef} from 'react'
import NaverMap from '../libs/NaverMap.tsx'
import {Branch} from '../types'
import './App.css'

declare global {
    const mwbmSingleBranchMap: {
        data: {
            className: string
            id: string
            branch: Branch
            height: string
            markerIcon?: string
            width: string
        }
    }
}

export default function App() {
    console.log('mwbmSingleBranchMap', mwbmSingleBranchMap)

    const {
        className,
        id,
        branch,
        height,
        markerIcon,
        width,
    } = mwbmSingleBranchMap.data

    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (ref.current) {
            const root: HTMLDivElement | null = ref.current.closest('[data-mwbm-app-root]')
            if (root) {
                root.style.width = width;
                root.style.height = height;
            }
            root?.removeChild(ref.current)
        }
    }, [])

    return (
        <Fragment>
            <NaverMap
                className={className}
                markers={[branch.coord]}
                id={id}
                markerIcon={markerIcon}
            />
            <span ref={ref}></span>
        </Fragment>
    )
}
